import { Box, IconButton } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { faBell } from "@outschool/icons";
import React from "react";

interface NotificationBellButtonProps {
  onClick: () => void;
  isPanelOpen: boolean;
  hasUnreadNotifications: boolean;
  buttonRef?: React.Ref<HTMLElement>;
}

function NotificationBellButton(
  {
    onClick,
    isPanelOpen,
    buttonRef,
    hasUnreadNotifications,
  }: NotificationBellButtonProps,
  containerRef?: React.Ref<HTMLElement>,
) {
  return (
    <Box
      ref={containerRef}
      sx={{
        position: "relative",
      }}
    >
      {hasUnreadNotifications && !isPanelOpen && (
        <Box
          data-test-id={"new-notification-indicator"}
          sx={{
            position: "absolute",
            right: 8,
            top: "10px",
            zIndex: 1,
            backgroundColor: "#FF0C0C",
            borderRadius: "50%",
            width: "12px",
            height: "12px",
            pointerEvents: "none",
          }}
        />
      )}

      <IconButton
        data-test-id={"notification-bell-button"}
        trackingName="inAppNotifications.bellButton"
        trackingSharedProperties={{
          hasUnreadNotifications,
          isPanelOpen,
          ignoreNetworkError: true,
        }}
        onClick={onClick}
        icon={faBell}
        ref={buttonRef}
        sx={{
          marginLeft: 12,
          padding: 8,
          boxSizing: "content-box",
          fontSize: 28,
          border: "none",
        }}
      />
    </Box>
  );
}

export default React.forwardRef<HTMLElement, NotificationBellButtonProps>(
  NotificationBellButton,
);
